import { render, staticRenderFns } from "./terminationForm.vue?vue&type=template&id=879ff030"
import script from "./terminationForm.vue?vue&type=script&lang=js"
export * from "./terminationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports